import React from "react"

import * as styles from "../index.module.scss"

export type Props = {
  jsonTable: {
    columns: string[]
    data: Record<string, string>[]
  }
}

const JsonTable = ({ jsonTable }: Props) => {
  const items = jsonTable.data.map(Object.values)
  return (
    <div className={styles.tableContainer}>
      <table>
        <thead>
          <tr>
            {jsonTable.columns.map(column => (
              <th key={column}>{column}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {items.map(rows => {
            return (
              <tr key={`tr-${rows.join(",")}`}>
                {rows.map((cell, index, array) => (
                  <td key={array.slice(0, index).join(",")}>{cell}</td>
                ))}
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export default JsonTable
